var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTkt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 17,
    viewBox: "0 0 72 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.7037 -0.00524902H0V4.88931C1.90247 4.88931 3.44039 6.42956 3.44039 8.3349C3.44039 10.2402 1.90247 11.7805 0 11.7805V16.6865H40.7037",
    fill: "#009DF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7041 16.6865H71.6562V11.7805C69.7538 11.7805 68.2158 10.2402 68.2158 8.3349C68.2158 6.42956 69.7538 4.88931 71.6562 4.88931V-0.00524902H40.7041",
    fill: "#FF005F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0636 14.5187H8.72572V5.12888H6.8916V2.16248H13.966V5.12888H12.0522V14.5187H12.0636Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8797 14.5187H21.2799L19.0698 8.82547L19.1609 14.5187H15.8345V2.16248H19.1609L19.0698 7.45636L21.0406 2.16248H24.5608L21.895 8.12951L24.8797 14.5187Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8404 14.5187H28.5026V5.12888H26.6685V2.16248H33.7429V5.12888H31.829V14.5187H31.8404Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1527 7.37653H56.8006V7.88995C56.8006 10.2745 56.4475 11.9859 55.7412 13.0241C54.9665 14.165 53.8273 14.7355 52.3122 14.7355C50.8198 14.7355 49.6578 14.1764 48.8148 13.0583C47.9718 11.9288 47.5503 10.3772 47.5503 8.40336C47.5503 6.40675 47.9718 4.82086 48.8262 3.66853C49.6692 2.5162 50.8312 1.93433 52.3008 1.93433C54.2488 1.93433 55.6614 2.94975 56.5386 4.992L53.3147 6.17856C53.2691 5.79065 53.1552 5.4826 52.9843 5.25441C52.8134 5.02623 52.597 4.91214 52.3349 4.91214C51.4236 4.91214 50.9565 6.17856 50.9565 8.70001C50.9565 9.77247 51.059 10.5483 51.2641 11.0389C51.4692 11.5295 51.7881 11.7691 52.2324 11.7691C52.4033 11.7691 52.5628 11.7235 52.7109 11.6436C52.859 11.5637 52.9729 11.4382 53.0754 11.2785C53.178 11.1188 53.2463 10.9362 53.3033 10.7194C53.3602 10.5027 53.383 10.2517 53.383 9.97784H52.1527V7.37653Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5776 14.5187V2.16248H64.7635V5.07183H61.9041V6.87449H64.4787V9.66975H61.9155V11.5637H64.7749V14.5301H58.5776V14.5187Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7031 11.7803C42.6032 11.7803 44.1435 10.2377 44.1435 8.33475C44.1435 6.4318 42.6032 4.88916 40.7031 4.88916C38.803 4.88916 37.2627 6.4318 37.2627 8.33475C37.2627 10.2377 38.803 11.7803 40.7031 11.7803Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTkt);
export default __webpack_public_path__ + "static/media/tkt.b4ac5b4d6d49b6c21a046b0324df655e.svg";
export { ForwardRef as ReactComponent };